import request from '@/utils/request';

// 自动合单配置查询
export function queryAutoMergeConfigApi(data) {
  return request({
    baseURL: '/tb-api/',
    url: '/autoMergeConfig/queryConfig',
    method: 'POST',
    data
  });
}
// 自动合单配置设置
export function addAutoMergeConfigApi(data) {
  return request({
    baseURL: '/tb-api/',
    url: '/autoMergeConfig/addConfig',
    method: 'POST',
    data
  });
}
// 按orderId更新订单接口
export function syncOrderByOrderIdApi(data) {
  return request({
    baseURL: '/tb-api/alibaba/',
    url: '/order/synOrderByOrderId',
    method: 'POST',
    data
  });
}
// 按时间段更新订单接口
export function syncTimeSlotOrdersApi(data) {
  return request({
    baseURL: '/tb-api/alibaba/',
    url: '/order/synOrderByTime',
    method: 'POST',
    data
  });
}
/**
 * 获取列表数据接口
 * @param {*} data
 * @param {*} func：
 * 不合并订单：listOrder | 自动合并订单：getAllOrdersNew
 */
export function getOrdersListApi(data, func = 'getAllOrdersNew') {
  return request({
    baseURL: '/tb-api/alibaba/',
    url: '/order/' + func,
    method: 'POST',
    data
  });
}
// 查询订单同步状态接口
export function queryAliOrderSyncProApi(data) {
  return request({
    baseURL: '/tb-api/alibaba/',
    url: '/order/getSynOrderFlag',
    method: 'POST',
    data
  });
}
// 查询统计数据接口
export function syncStatisticApi(data) {
  return request({
    baseURL: '/tb-api/alibaba/',
    url: '/order/statistic',
    method: 'POST',
    data
  });
}
// 订单查询店铺是否授权
export function aliMallIfAuthorizedApi(data) {
  return request({
    baseURL: '/tb-api/alibaba/',
    url: '/order/mallIfAuthorized',
    method: 'post',
    data
  });
}
// 查询列配置
export function queryAliUserColumnConfigApi(data) {
  return request({
    baseURL: '/tb-api/alibaba/',
    url: '/columnConfig/queryUserColumnConfig',
    method: 'POST',
    data
  });
}
// 修改列配置
export function addAliUserColumnConfigApi(data) {
  return request({
    baseURL: '/tb-api/alibaba/',
    url: '/columnConfig/addUserColumnConfig',
    method: 'POST',
    data
  });
}
// 重置列配置
export function resetAliUserColumnConfigApi(data) {
  return request({
    baseURL: '/tb-api/alibaba/',
    url: '/columnConfig/resetUserColumnConfig',
    method: 'POST',
    data
  });
}
// 查询商品信息配置
export function queryMallColumnConfigApi(data) {
  return request({
    baseURL: '/tb-api/alibaba/',
    url: '/columnConfig/queryMallColumnConfig',
    method: 'POST',
    data
  });
}
// 修改商品信息配置
export function addMallColumnConfigApi(data) {
  return request({
    baseURL: '/tb-api/alibaba/',
    url: '/columnConfig/addMallColumnConfig',
    method: 'POST',
    data
  });
}
// 设置商品简称接口
export function updateAliProductAliasApi(data) {
  return request({
    baseURL: '/tb-api/alibaba/',
    url: '/product/updateProductAlias',
    method: 'POST',
    data
  });
}
// 客户管家-拉单接口
export function getApplyOrdersApi(data) {
  return request({
    baseURL: '/tb-api/alibaba/',
    url: '/order/applyWaybill',
    method: 'POST',
    data
  });
}
// 查询打印快递单、简称、发货单选项-勾选状态
export function syncPrintCheckStatusApi(data) {
  return request({
    baseURL: '/tb-api/',
    url: '/commonMall/queryMallConfig',
    method: 'POST',
    data
  });
}
/**
 * 更新打印快递单、简称、发货单选项-勾选状态
 * @param {*} data
 * 店铺Code、同时打印发货单、打印后立即发货、打印商品简称
 * {"mallCode":"","printCheck":{"bothDelivery":true,"deliveryAfterPrint":true,"printShort":true}}
 * @returns
 */
export function syncUpdatePrintCheckStatusApi(data) {
  return request({
    baseURL: '/tb-api/',
    url: '/commonMall/updateMallConfig',
    method: 'POST',
    data
  });
}
// 更新发货单状态接口
export function syncUpdateDeliverStatusApi(data){
  return request({
    baseURL: '/tb-api/alibaba/',
    url: '/applyOrders/updateDeliverStatus',
    method: 'POST',
    data
  });
}
// 查询打印次数列表接口
export function queryPrintCountListApi(data) {
  return request({
    baseURL: '/tb-api/alibaba/',
    url: '/order/getOrderPrintHist',
    method: 'POST',
    data
  });
}
/**
 * 发货接口
 * @param {*} data
 * @param {*} func : send_offline-发货 | shipmentsReSend-重新发货
 */
export function syncSendGoodsApi(data, func) {
  return request({
    baseURL: '/tb-api/alibaba/',
    url: '/order/' + func,
    method: 'POST',
    data
  });
}
/**
 * 查询历史老单号记录接口
 */
export function getCanSelectOrderMailNoListApi(data) {
  return request({
    baseURL: '/tb-api/alibaba/',
    url: '/order/getOrderOldWaybillNoList',
    method: 'POST',
    data
  });
}
/**
 * 拆单合单接口
 * @param {*} data
 * @param {*} func：
 * /getPreMergeList  查询待合列表接口
 * /mergeOrder 手动合单
 * /splitOrder 手动拆单-拆子单接口
 * /splitOrderAll  手动单个合单拆分 - 交易单
 * /mergeOrderAll	自动合并列表所有待合（入参：无参）
 * /splitUserAllOrder 自动拆分所有合并未打印订单 拆单接口 （入参：无参）
 */
export function syncMergeSplitOrderApi(data, func) {
  return request({
    // baseURL: '/tiaoshi/',
    baseURL: '/tb-api/alibaba/',
    url: '/order/' + func,
    method: 'POST',
    data
  });
}
/**
 * 批量|单个 订单锁定 & 解锁接口
 * @param {*} data
 * @returns
 */
 export function syncLockOrdersApi(data){
  return request({
    baseURL: '/tb-api/alibaba/',
    url: '/order/lockOrders',
    method: 'POST',
    data
  });
}
/**
 * 修改收件人信息 & 备注接口
 * @param {*} data
 * 淘宝旺旺昵称字段buyerNick必传
 * 修改备注时传id、buyerMemo、sellerMemo字段 | 修改收件人信息时传id、和receiver开头的字段
 * @param {*} func：
 */
export function syncReceiverInfoApi(data, func) {
  return request({
    baseURL: '/tb-api/alibaba/',
    url: '/order/' + func,
    method: 'POST',
    data
  });
}
/**
 * 更新卖家备注(备注内容和旗帜) - 新
 * @param {*} data
 * @returns
 */
export function syncUpdateSellerMemoApi(data) {
  return request({
    baseURL: '/tb-api/alibaba/',
    url: '/order/updateSellerMemo',
    method: 'POST',
    data
  });
}
// 获取商品名称&规格数据接口
export function syncAliProductListApi(data) {
  return request({
    baseURL: '/tb-api/alibaba/',
    url: '/product/list',
    method: 'post',
    data
  });
}
export function aliGetAllOrderNewProductApi(data) {
  return request({
    baseURL: '/tb-api/alibaba/',
    url: '/product/getAllOrderNewProduct',
    method: 'post',
    data
  });
}
// 导出数据
export function syncExportOrderApi(data){
  return request({
    baseURL: '/tb-api/alibaba/',
    url: '/order/export',
    method: 'POST',
    responseType: 'blob',
    data
  });
}
// 同步订单
export function syncAliOrdersByManualApi(data) {
  return request({
    baseURL: '/tb-api/alibaba/',
    url: '/order/orderSync/' + data,
    method: 'post'
  })
}
// 买家旺旺解密
export function decryptWangWangNickApi(data) {
  return request({
    baseURL: '/tb-api/alibaba/',
    url: '/order/openUidDecryptToWangWang',
    method: 'post',
    data
  })
}
// 选择订单-拆单接口
export function splitBatchOrderApi(data) {
  return request({
    baseURL: '/tb-api/alibaba/',
    url: '/order/splitBatchOrder',
    method: 'post',
    data
  });
}
// 更新圆通优选时效的接口
export function o688YtoPerferTimeFlagSynApi(data) {
  return request({
    baseURL: '/tb-api/alibaba/',
    url: '/order/ytoPerferTimeFlagSyn',
    method: 'post',
    data
  });
}
// 保存管家备注接口
export function updateAliKhgjRemarkApi(data) {
  return request({
    baseURL: '/tb-api/alibaba/',
    url: '/order/updateKhgjRemark',
    method: 'post',
    data
  });
}
